



























import { Vue, Component, Prop } from 'vue-property-decorator';
import { PartnerLogoViewModel } from '@/types/apiServerContract';
import AdnuntiusPixels from '@/project/tracking/adnuntius/AdnuntiusPixels.vue';
import authService from '@/core/auth/auth.service';
import dictionaryService from '@/core/translation/dictionary.service';
import formatEmailAsHtml from '@/core/formatters/emailAsHtml.service';

@Component({
    components: { AdnuntiusPixels }
})
export default class ProductDetailsPartnerLogos extends Vue {
    @Prop({ required: true, type: Array })
    private partners!: readonly PartnerLogoViewModel[];

    private imageCssClass(partner: PartnerLogoViewModel) : string {
        const isTall = partner.image.width < partner.image.height;
        const isSquare = partner.image.width === partner.image.height;

        return isTall || isSquare ? 'brand-logo-max-h' : 'brand-logo-max-w';
    }

    private get isUserLoggedIn(): boolean {
        return authService.isLoggedIn();
    }

    private get subtitle() {
        return formatEmailAsHtml(dictionaryService.get('Product.Details.Partners.Subtitle'));
    }
}
